import { render, staticRenderFns } from "./blockInvoices.vue?vue&type=template&id=85a464a2&scoped=true&"
import script from "./blockInvoices.vue?vue&type=script&lang=js&"
export * from "./blockInvoices.vue?vue&type=script&lang=js&"
import style0 from "./blockInvoices.vue?vue&type=style&index=0&id=85a464a2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a464a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85a464a2')) {
      api.createRecord('85a464a2', component.options)
    } else {
      api.reload('85a464a2', component.options)
    }
    module.hot.accept("./blockInvoices.vue?vue&type=template&id=85a464a2&scoped=true&", function () {
      api.rerender('85a464a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/blockInvoices/blockInvoices.vue"
export default component.exports